document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-accessory-page]').forEach(root=>{
    const main=root.querySelector('[data-ap-main]');
    const thumbs=[...root.querySelectorAll('[data-ap-photo]')];
    const dialog=root.querySelector('dialog');
    let index=0;
    const show=n=>{
      index=(n+thumbs.length)%thumbs.length;
      const img=thumbs[index].querySelector('img');
      main.src=img.dataset.original||img.src;main.alt=img.alt;if(img.dataset.srcset){main.srcset=img.dataset.srcset;}else{main.removeAttribute('srcset');}
      root.querySelector('[data-ap-count]').textContent=(index+1)+' / '+thumbs.length;
      thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    };
    thumbs.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
    root.querySelectorAll('[data-ap-step]').forEach(button=>button.addEventListener('click',()=>show(index+Number(button.dataset.apStep))));
    root.querySelector('.ap-gallery').addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));}
    });
    root.querySelector('[data-ap-zoom]').addEventListener('click',()=>{
      const img=root.querySelector('[data-ap-full]');img.src=main.src;img.alt=main.alt;dialog.showModal();
    });
    root.querySelector('[data-ap-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  });
});
